<template>
  <v-overlay :value="value" :z-index="zIndex" :opacity="opacity">
    <div class="loading-container">
      <!-- GIF de Loading -->
      <div class="loading-icon-wrapper">
        <img
            src="../../assets/icons/Gif_Loading_Gestor.gif"
            alt="Carregando..."
            class="loading-icon"
        />
      </div>

      <!-- Texto de carregamento -->
      <div class="loading-text">
        <h3 class="white--text font-weight-medium mb-2">
          {{ message }}
        </h3>
        <p class="text-body-2 white--text text-center" style="opacity: 0.85;">
          {{ subtitle }}
        </p>
      </div>

      <!-- Barra de progresso (opcional) -->
      <v-progress-linear
          v-if="showProgress"
          :indeterminate="!progress"
          :value="progress"
          color="white"
          height="3"
          rounded
          class="loading-progress"
      ></v-progress-linear>
    </div>
  </v-overlay>
</template>

<script>
export default {
  name: 'CarregamentoGestor',

  props: {
    value: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: 'Carregando'
    },
    subtitle: {
      type: String,
      default: 'Por favor, aguarde...'
    },
    zIndex: {
      type: Number,
      default: 9999
    },
    opacity: {
      type: Number,
      default: 0.85
    },
    showProgress: {
      type: Boolean,
      default: false
    },
    progress: {
      type: Number,
      default: null
    }
  }
}
</script>

<style scoped>
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

/* Wrapper do ícone com animação sutil */
.loading-icon-wrapper {
  margin-bottom: 0;
  animation: float 3s ease-in-out infinite;
}

.loading-icon {
  width: 250px;
  height: 250px;
  object-fit: contain;
  filter: drop-shadow(0 8px 16px rgba(0, 0, 0, 0.3));
}

/* Animação de flutuação */
@keyframes float {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}

/* Texto de carregamento */
.loading-text {
  margin-bottom: 20px;
  max-width: 400px;
  animation: fadeIn 0.5s ease-in;
}

.loading-text h3 {
  font-size: 1.5rem;
  letter-spacing: 0.5px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.loading-text p {
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

/* Barra de progresso */
.loading-progress {
  width: 280px;
  margin-top: 8px;
  animation: fadeIn 0.5s ease-in 0.3s both;
}

/* Animação de entrada */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsividade */
@media (max-width: 600px) {
  .loading-icon {
    width: 90px;
    height: 90px;
  }

  .loading-text h3 {
    font-size: 1.25rem;
  }

  .loading-progress {
    width: 220px;
  }
}
</style>